import axios, { AxiosError, AxiosResponse, CancelToken } from "axios";
import axiosClient from "./axiosClient";
import { response } from "./dataType";
import { getAccessTokenFromLocalStorage } from "../include/token";
import { loader } from "../context/loaderSingleton"; // Shared loader handler

type RequestOptions = {
  silent?: boolean;
  cancelToken?: CancelToken;
};

export const dataPost = async (
  url: string,
  data: any,
  options: RequestOptions = { silent: true }
): Promise<response> => {
  const jwtToken = getAccessTokenFromLocalStorage();
  if (!options.silent) loader.setLoading(true);

  try {
    const response: AxiosResponse<response> = await axiosClient.post(
      url,
      data,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      // if (axiosError.response?.status === 401) {
      //   return new Promise<response>((resolve) => {
      //     const jsonData: response = {
      //       status: false,
      //       title: axiosError.code ?? "Error",
      //       message: axiosError.message,
      //       data: [],
      //       code: 401,
      //     };
      //     resolve(jsonData);
      //   });
      // }
      if (axiosError.response?.status && axiosError.response?.data) {
        const data = axiosError.response.data as {
          data: any;
          message?: string;
          error?: string;
          title?: string;
        };
        return new Promise<response>((resolve) => {
          const jsonData: response = {
            status: false,
            title: data.title ?? "Error",
            message: data.message ?? "Bad Request",
            data: data.data ?? {},
            code: axiosError.response?.status,
          };
          resolve(jsonData);
        });
      }
    }
    return new Promise<response>((resolve) => {
      const jsonData: response = {
        status: false,
        title: "Server Error",
        message: "Please check the server server is not responding ",
        data: {},
      };
      resolve(jsonData);
    });
  } finally {
    if (!options.silent) loader.setLoading(false);
  }
};

export const dataGet = async (
  url: string,
  data: any,
  source?: CancelToken,
  options: RequestOptions = { silent: true }
): Promise<response> => {
  const jwtToken = getAccessTokenFromLocalStorage();
  if (!options.silent) loader.setLoading(true);

  try {
    const response: AxiosResponse<response> = await axiosClient.get(url, {
      params: data,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
      cancelToken: source,
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return new Promise<response>((resolve) => {
        const jsonData: response = {
          status: false,
          title: "cancel",
          message: "cancel",
          data: [],
          hide: true,
        };
        resolve(jsonData);
      });
    }

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 401) {
        return new Promise<response>((resolve) => {
          const jsonData: response = {
            status: false,
            title: axiosError.code ?? "Error",
            message: axiosError.message,
            data: [],
            code: 401,
          };
          resolve(jsonData);
        });
      }
    }

    return new Promise<response>((resolve) => {
      const jsonData: response = {
        status: false,
        title: "Server Error",
        message: "Please check the server server is not responding ",
        data: [],
      };
      resolve(jsonData);
    });
  } finally {
    if (!options.silent) loader.setLoading(false);
  }
};

export const dataPut = async (
  url: string,
  data: any,
  options: RequestOptions = { silent: true }
): Promise<response> => {
  const jwtToken = getAccessTokenFromLocalStorage();
  if (!options.silent) loader.setLoading(true);

  try {
    const response: AxiosResponse<response> = await axiosClient.put(url, data, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      // if (axiosError.response?.status === 401) {
      //   return new Promise<response>((resolve) => {
      //     const jsonData: response = {
      //       status: false,
      //       title: axiosError.code ?? "Error",
      //       message: axiosError.message,
      //       data: [],
      //       code: 401,
      //     };
      //     resolve(jsonData);
      //   });
      // }
      if (axiosError.response?.status && axiosError.response?.data) {
        const data = axiosError.response.data as {
          message?: string;
          error?: string;
          title?: string;
        };
        return new Promise<response>((resolve) => {
          const jsonData: response = {
            status: false,
            title: data.title ?? "Error",
            message: data.message ?? "Bad Request",
            data: [],
            code: axiosError.response?.status,
          };
          resolve(jsonData);
        });
      }
    }
    return new Promise<response>((resolve) => {
      const jsonData: response = {
        status: false,
        title: "Server Error",
        message: "Please check the server server is not responding ",
        data: [],
      };
      resolve(jsonData);
    });
  } finally {
    if (!options.silent) loader.setLoading(false);
  }
};
